import { render, staticRenderFns } from "./customizationFeaturedSponsorsSection.vue?vue&type=template&id=3d29af88"
import script from "./customizationFeaturedSponsorsSection.vue?vue&type=script&lang=js"
export * from "./customizationFeaturedSponsorsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports